import React from 'react';
import c from 'classnames';

import { SearchStats } from '@uncinc/react-searchkit';
import { SearchStatsProps } from '@uncinc/react-searchkit/dist/components/Stats';

const SearchAllContentStats: React.FC<SearchStatsProps> = () => {
  const classNames = c('SearchAllContent__Stats', 'asH2', 'mb-0');

  return (
    <SearchStats className={classNames} hiddenWhenEmpty />
  );
};

export default SearchAllContentStats;
